import * as Contexts from "../contexts";

// tslint:disable-next-line:variable-name
export const ClientConfigConsumer = Contexts.clientConfigContext.Consumer;
